import React, { useState } from 'react';
import { PlusIcon } from './icons/PlusIcon';

interface AddButtonPopProps {
    onClick: () => void;
    isOpen: boolean;
    onConfirm: (val1: string, val2: string) => void;
    titlePlaceholder?: string;
    urlPlaceholder?: string;
    buttonText?: string;
    isAdmin?: boolean;
    isTextarea?: boolean;
    input1Type?: string;
    input2Type?: string;
}

const AddButtonPop: React.FC<AddButtonPopProps> = ({
    onClick,
    isOpen,
    onConfirm,
    titlePlaceholder = "Title",
    urlPlaceholder = "URL",
    buttonText = "Save",
    isAdmin = false,
    isTextarea = false,
    input1Type = "text",
    input2Type = "text"
}) => {
    const [val1, setVal1] = useState('');
    const [val2, setVal2] = useState('');

    const handleSubmit = () => {
        if (val1.trim() && val2.trim()) {
            onConfirm(val1, val2);
            setVal1('');
            setVal2('');
            onClick(); // Close or toggle state
        }
    };

    if (!isAdmin) return null;

    return (
        <>
            <button
                onClick={onClick}
                className="absolute -top-12 right-0 p-1.5 bg-fuchsia-100 text-fuchsia-600 rounded-lg hover:bg-fuchsia-200 transition-colors z-10"
                title={isOpen ? "Cancel" : "Add new"}
            >
                <PlusIcon className={`w-5 h-5 transition-transform ${isOpen ? 'rotate-45' : ''}`} />
            </button>

            {isOpen && (
                <div className="bg-white/60 p-3 rounded-xl space-y-2 border-2 border-fuchsia-100 animate-in fade-in slide-in-from-top-2 mb-2">
                    <input
                        type={input1Type}
                        placeholder={titlePlaceholder}
                        value={val1}
                        onChange={(e) => setVal1(e.target.value)}
                        autoFocus
                        className="w-full bg-white/80 border border-transparent focus:border-fuchsia-300 rounded-lg px-3 py-2 text-sm outline-none transition-all placeholder:text-gray-400 text-gray-700"
                    />
                    {isTextarea ? (
                        <textarea
                            placeholder={urlPlaceholder}
                            value={val2}
                            onChange={(e) => setVal2(e.target.value)}
                            className="w-full bg-white/80 border border-transparent focus:border-fuchsia-300 rounded-lg px-3 py-2 text-sm outline-none transition-all placeholder:text-gray-400 text-gray-700 resize-none h-20"
                        />
                    ) : (
                        <input
                            type={input2Type}
                            placeholder={urlPlaceholder}
                            value={val2}
                            onChange={(e) => setVal2(e.target.value)}
                            className="w-full bg-white/80 border border-transparent focus:border-fuchsia-300 rounded-lg px-3 py-2 text-sm outline-none transition-all placeholder:text-gray-400 text-gray-700"
                        />
                    )}
                    <button
                        onClick={handleSubmit}
                        disabled={!val1.trim() || !val2.trim()}
                        className="w-full bg-fuchsia-600 hover:bg-fuchsia-700 disabled:opacity-50 disabled:cursor-not-allowed text-white py-1.5 rounded-lg transition-colors font-bold text-sm"
                    >
                        {buttonText}
                    </button>
                </div>
            )}
        </>
    );
};

export default AddButtonPop;
